import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
})
export class LanguageSelectorComponent implements OnInit {
  @Input() variant: 'welcome' | 'main' = 'main';

  currentLanguage = 'en';
  supportedLanguages = ['en', 'de', 'fr', 'it'];

  constructor(private translationService: TranslateService) {}

  ngOnInit() {
    this.initializeLanguage();
  }

  initializeLanguage() {
    const savedLang = localStorage.getItem('ecu-instant-payment-language');
    const browserLang = navigator.language.split('-')[0];

    const userLang =
      savedLang ||
      (this.supportedLanguages.includes(browserLang) ? browserLang : 'en');

    this.currentLanguage = userLang;
    this.translationService.use(userLang);
  }

  changeLanguage(language: string) {
    this.currentLanguage = language;
    this.translationService.use(language);
    localStorage.setItem('ecu-instant-payment-language', language);
  }
}
